import Parameter from "./parameter";
import IGdprPolicyItem from "../interface/gdpr-policy-item";
import ParamStorage from "../enum/param-storage";
import GdprStatus from "../enum/gdpr-status";
import ParameterStorage from "../class/parameter-storage";

class GdprPolicyInstance {

    public async isAllowed(email: string): Promise<boolean> {
        const items: IGdprPolicyItem[] = await this.getAll();
        const item: IGdprPolicyItem | undefined = items.find(i => i.email === email);
        return !!item && item.status === GdprStatus.Allowed;
    }

    public async set(email: string, status: GdprStatus, date: string = ''): Promise<void> {
        const items: IGdprPolicyItem[] = await this.getAll();
        const item: IGdprPolicyItem | undefined = items.find(i => i.email === email);
        if (item) {
            item.status = status;
            item.date = date || (new Date()).toISOString();
            await this.getStore().update(item);
        } else {
            await this.getStore().create({
                status,
                date: date || (new Date()).toISOString(),
                email
            });
        }
    }

    public async getAll(): Promise<IGdprPolicyItem[]> {
        await this.getStore().loadStorage();
        return this.getStore().getAll();
    }

    /* Private Methods */

    private getStore(): ParameterStorage<IGdprPolicyItem> {
        return Parameter.get(ParamStorage.EmailGdprPolicy);
    }
}

const GdprPolicy = new GdprPolicyInstance();

export default GdprPolicy;